export type CheckoutShippingMethod = Readonly<{
  id: number
  priceJpy: number
  description?: string
  shippingService: Readonly<{
    id: number
    label: string
  }>
}>

export type CheckoutShippingChoice = Readonly<{
  id: number
  name: string
  fee: string
}>

const checkoutShippingChoice = (
  method: CheckoutShippingMethod,
  methods: readonly CheckoutShippingMethod[],
  methodName: string,
  feeText: string,
): CheckoutShippingChoice => {
  const duplicates = methods.filter(other => other.shippingService.id === method.shippingService.id)
  let name = methodName

  if (duplicates.length > 1) {
    const index = methods.findIndex(other => other.id === method.id) + 1
    name = `${methodName} ${index}`

    if (method.description) name = `${name} (see notes)`
  }

  return {
    id: method.id,
    name,
    fee: feeText,
  }
}

const joinCheckoutShippingLabel = (choice: CheckoutShippingChoice): string => {
  return `${choice.name}: ${choice.fee}`
}

export { checkoutShippingChoice, joinCheckoutShippingLabel }
